import { render } from "./ModalEditEmailBill.vue?vue&type=template&id=ec567068"
import script from "./ModalEditEmailBill.vue?vue&type=script&lang=js"
export * from "./ModalEditEmailBill.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__